import StreamsixIconDark from '../../assets/S6_full_logo_dark.png';
import StreamsixIcon from '../../assets/S6_full_logo.svg';
import { Image, useColorMode } from '@chakra-ui/react';

interface StreamsixBannerProps {
    className?: string;
}

export const StreamsixBanner = (props: StreamsixBannerProps) => {
    const { colorMode } = useColorMode();

    return (
        <Image
            className={props.className}
            src={colorMode === 'light' ? StreamsixIcon : StreamsixIconDark}
        />
    );
};
